// @ts-nocheck
import React, { useCallback, useEffect, useState } from 'react';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';

import Overview from '../Overview';
import useModelInventory from '../../../../hooks/ModelInventory/useModelInventory';
import useEntity from '../../../../hooks/Configuration/useEntity';

const ViewEntityDetailsModal = ({ open, handleClose, selectedEntity }) => {
  const { getCustomEntityTemplate } = useEntity();
  const { getAttributeDetails } = useModelInventory();

  const [formDetails, setFormDetails] = useState([]);
  const [attributeDetails, setAttributeDetails] = useState({});

  const handleGetAttributesData = useCallback(() => {
    getAttributeDetails({
      entity_type: selectedEntity?.entity_type,
      entity_id: selectedEntity?.entity_id,
    }).then((res) => {
      if (res?.data) {
        setAttributeDetails(res?.data);
      }
    });
  }, [selectedEntity?.entity_id, getAttributeDetails, setAttributeDetails]);

  const handleGetFormDetails = () => {
    getCustomEntityTemplate({
      entityId: selectedEntity?.entity_id,
      entityType: selectedEntity?.entity_type,
    }).then((resp) => {
      if (resp?.data) {
        setFormDetails(resp?.data);
      }
    });
  };

  useEffect(() => {
    if (selectedEntity) {
      handleGetFormDetails();
      handleGetAttributesData();
    }
  }, [selectedEntity]);

  return (
    <Dialog maxWidth="lg" open={open} onClose={handleClose} fullWidth>
      <DialogTitle>
        <Box component="span" aria-live="polite" aria-atomic="true">
          Entity details
        </Box>
      </DialogTitle>

      <IconButton
        color="primary"
        aria-label="Close dialog"
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 16,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers>
        <Overview
          formDetails={formDetails}
          attributeDetails={attributeDetails}
          mode="view"
        />
      </DialogContent>
    </Dialog>
  );
};

ViewEntityDetailsModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  selectedEntity: PropTypes.shape({
    entity_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    entity_type: PropTypes.string,
    entity_alias: PropTypes.string,
    entity_code: PropTypes.string,
    entity_name: PropTypes.string,
  }),
};

export default ViewEntityDetailsModal;
